var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerLookup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40964",
    "data-name": "Group 40964",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15548",
    "data-name": "Rectangle 15548",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_1_",
    transform: "translate(1.499 1.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2906",
    "data-name": "Ellipse 2906",
    cx: 8.787,
    cy: 8.787,
    r: 8.787,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2778",
    "data-name": "Line 2778",
    x1: 6,
    y1: 6,
    transform: "translate(15 15)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40964-2",
    "data-name": "Group 40964",
    transform: "translate(2.627 2.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1322",
    transform: "translate(0 5.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1324",
    d: "M12.319-135.118a6.169,6.169,0,0,0-6.159-5.828A6.169,6.169,0,0,0,0-135.117",
    transform: "translate(0 140.946)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1328",
    d: "M-140.593-67.39a2.907,2.907,0,0,0,2.907,2.907,2.907,2.907,0,0,0,2.907-2.907,2.907,2.907,0,0,0-2.907-2.907A2.907,2.907,0,0,0-140.593-67.39Z",
    transform: "translate(143.846 70.297)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerLookup);
export default __webpack_public_path__ + "static/media/customer-lookup.2738c9fac99cecc56b10ee176a586164.svg";
export { ForwardRef as ReactComponent };